<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>The Defiant</h1>
<h1 class="bk1">Protest Movements in Post-Liberal America</h1>
<p class="bkau">Dawson Barrett</p>
<p class="bkpub"><img alt="" height="44" src="images/NYU_TitlePage_Logo.jpg" width="35"/></p>
<p class="bkpub">New York University Press</p>
<p class="bkpub1">New York</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// barretthedefiant-0003.vue?0fe46c10